export const iconsMap: Record<string, string> = {
  icon_thumbs_up: '👍',
  icon_thumbs_down: '👎',
  add_calender: '\uE900',
  add_contact: '\uE901',
  after_workshop: '\uE902',
  untitled: '\uE903',
  app_lounge: '\uE904',
  app_mymeetings: '\uE905',
  arrow_down: '\uE906',
  arrow_left: '\uE907',
  arrow_right: '\uE908',
  arrow_up: '\uE909',
  ask_the_audience: '\uE90A',
  attendee: '\uE90B',
  audit_debate: '\uE90C',
  availability: '\uE90D',
  award: '\uE90E',
  barcamp: '\uE90F',
  bootcamp: '\uE910',
  breakfast_club: '\uE911',
  case_study: '\uE912',
  challenge_peers: '\uE913',
  check: '\uE914',
  clock: '\uE915',
  close: '\uE916',
  conect: '\uE917',
  contact: '\uE918',
  deep_diving: '\uE919',
  dinner: '\uE91A',
  download: '\uE91B',
  edit: '\uE91C',
  elevator: '\uE91D',
  evening_session: '\uE91E',
  factory_visit: '\uE91F',
  feedback: '\uE920',
  fishbowl: '\uE921',
  floorplan: '\uE922',
  food_drinks: '\uE923',
  graphic_recording: '\uE924',
  hackathon: '\uE925',
  home: '\uE926',
  hyperlink: '\uE927',
  icebreaker: '\uE928',
  industry_reports: '\uE929',
  influencer: '\uE92A',
  info: '\uE92B',
  keynote: '\uE92C',
  list_view: '\uE92D',
  location: '\uE92E',
  lunch_session: '\uE92F',
  mail: '\uE930',
  meeting: '\uE931',
  message: '\uE932',
  minus: '\uE933',
  moderators: '\uE934',
  more: '\uE935',
  morning_session: '\uE936',
  my_event: '\uE937',
  networking_zone: '\uE938',
  newsletter: '\uE939',
  no_eight: '\uE93A',
  no_eighteen: '\uE93B',
  no_eleven: '\uE93C',
  no_five: '\uE93D',
  no_fiveteen: '\uE93E',
  no_four: '\uE93F',
  no_fourteen: '\uE940',
  no_nine: '\uE941',
  no_nineteen: '\uE942',
  no_one: '\uE943',
  no_seven: '\uE944',
  no_seventeen: '\uE945',
  no_six: '\uE946',
  no_sixteen: '\uE947',
  no_ten: '\uE948',
  no_thirteen: '\uE949',
  no_three: '\uE94A',
  no_twelve: '\uE94B',
  no_twenty: '\uE94C',
  no_two: '\uE94D',
  notes: '\uE94E',
  one_two_ones: '\uE94F',
  panel: '\uE950',
  partner: '\uE951',
  partner_education: '\uE952',
  partner_media: '\uE953',
  partnering: '\uE954',
  pending: '\uE955',
  pending_in: '\uE956',
  pending_out: '\uE957',
  phone: '\uE958',
  plus: '\uE959',
  polaroid: '\uE95A',
  poster_session: '\uE95B',
  pre_workshop: '\uE95C',
  profile: '\uE95D',
  quickfire_question: '\uE95E',
  rate_pitch: '\uE95F',
  reports: '\uE960',
  say_hello: '\uE961',
  search: '\uE962',
  sessions: '\uE963',
  settings: '\uE964',
  share: '\uE965',
  smile: '\uE966',
  smile_not: '\uE967',
  social_facebook: '\uE968',
  social_instagram: '\uE969',
  social_linkedin: '\uE96A',
  social_twitter: '\uE96B',
  social_xing: '\uE96C',
  social_youtube: '\uE96D',
  sorting_alphabet: '\uE96E',
  sorting_company: '\uE96F',
  sorting_filter: '\uE970',
  sorting_joblevel: '\uE971',
  speaker: '\uE972',
  star_selected: '\uE973',
  star_unselected: '\uE974',
  startup_lounge: '\uE975',
  survey: '\uE976',
  swipe_view: '\uE977',
  tech_take: '\uE978',
  ticket: '\uE979',
  toilets: '\uE97A',
  training_session: '\uE97B',
  tweetback: '\uE97C',
  update: '\uE97D',
  voting: '\uE97E',
  whitepaper: '\uE97F',
  wifi: '\uE980',
  workshop: '\uE981',
  workshop_advanced: '\uE982',
  world: '\uE983',
  world_cafe: '\uE984',
  zoom_in: '\uE985',
  zoom_out: '\uE986',
  touchpoint: '\uE987',
  open_fullscreen: '\uE988',
  menu: '\uE989',
  logout: '\uE98A',
  close_fullscreen: '\uE98B',
  priority_low: '\uE98C',
  priority_normal: '\uE98D',
  priority_high: '\uE98E',
  caret_arrow: '\uE98F',
  expectations: '\uE990',
  i_am_ai: '\uE991',
  smart_mobility_hub: '\uE992',
  add_attendee: '\uE993',
  add_image: '\uE994',
  heart_selected: '\uE995',
  heart_unselected: '\uE996',
  android: '\uE997',
  apple: '\uE998',
  driving_day: '\uE999',
  reply: '\uE99A',
  comments: '\uE99B',
  qr_code: '\uE99C',
  webinar: '\uE99D',
  webinar_live: '\uE99E',
  membership: '\uE99F',
  shopping_card: '\uE9A0',
  second_screen: '\uE9A1',
  stream_fullscreen: '\uE9A2',
  online_attendee: '\uE9A3',
  video_call: '\uE9A4',
  chat: '\uE9A5',
  play: '\uE9A6',
  question: '\uE9A7',
  eye: '\uE9A8',
  unlock: '\uE9A9',
  bell: '\uE9AA',
  agenda: '\uE9AB',
  caret_arrow_up: '\uE9AC',
  caret_arrow_left: '\uE9AD',
  caret_arrow_right: '\uE9AE',
  streaming: '\uE9AF',
  lock: '\uE9B0',
  onboarding: '\uE9B1',
  analytics: '\uE9B2',
  untitled1: '\uE9B3',
  untitled2: '\uE9B4',
  untitled3: '\uE9B5',
  app_machfinder: '\uE9B6',
  attendees: '\uE9B7',
  garbage: '\uE9B8',
  login: '\uE9B9',
  attention: '\uE9BA',
  pin: '\uE9BB',
  drag: '\uE9BC',
  eye_open: '\uE9BD',
  eye_closed: '\uE9BE',
  goodie_bag: '\uE9BF',
  upload: '\uE9C0',
  advert: '\uE9C1',
  paperclip: '\uE9C2',
  untitled4: '\uE9C3',
  untitled5: '\uE9C4',
  reset_back: '\uE9C5',
  untitled6: '\uE9C6',
  untitled7: '\uE9C7',
  send_plane_fill: '\uE9C8',
  external_link_line: '\uE9C9',
  settings_3_line: '\uE9CA',
  pin_filled: '\uE9CB',
  money: '\uE9CC',
  statistics: '\uE9CD',
  percent: '\uE9CE',
  hotel: '\uE9CF',
  shopping_cart: '\uE9D0',
  hubs101_mono: '\uE9D1',
  untitled8: '\uE9D2',
  untitled9: '\uE9D3',
  untitled10: '\uE9D4',
  video: '\uE9D5',
  untitled11: '\uE9D6',
  untitled12: '\uE9D7',
  untitled13: '\uE9D8',
  untitled14: '\uE9D9',
  untitled15: '\uE9DA',
  untitled16: '\uE9DB',
  untitled17: '\uE9DC',
  untitled18: '\uE9DD',
  untitled19: '\uE9DE',
  untitled20: '\uE9DF',
  untitled21: '\uE9E0',
  untitled22: '\uE9E1',
  untitled23: '\uE9E2',
  untitled24: '\uE9E3',
  untitled25: '\uE9E4',
  untitled26: '\uE9E5',
  untitled27: '\uE9E6',
  untitled28: '\uE9E7',
  untitled29: '\uE9E8',
  untitled30: '\uE9E9',
  untitled31: '\uE9EA',
  untitled32: '\uE9EB',
  untitled33: '\uE9EC',
  untitled34: '\uE9ED',
  untitled35: '\uE9EE',
  untitled36: '\uE9EF',
  untitled37: '\uE9F0',
  untitled38: '\uE9F1',
  untitled39: '\uE9F2',
  untitled40: '\uE9F3',
  untitled41: '\uE9F4',
  untitled42: '\uE9F5',
  untitled43: '\uE9F6',
  untitled44: '\uE9F7',
  untitled45: '\uE9F8',
  untitled46: '\uE9F9',
  untitled47: '\uE9FA',
  untitled48: '\uE9FB',
  untitled49: '\uE9FC',
  untitled50: '\uE9FD',
  untitled51: '\uE9FE',
  untitled52: '\uE9FF',
  untitled53: '\uEA00',
  untitled54: '\uEA01',
  untitled55: '\uEA02',
  untitled56: '\uEA03',
  untitled57: '\uEA04',
  untitled58: '\uEA05',
  untitled59: '\uEA06',
  untitled60: '\uEA07',
  untitled61: '\uEA08',
  untitled62: '\uEA09',
  untitled63: '\uEA0A',
  untitled64: '\uEA0B',
  untitled65: '\uEA0C',
  event_pages_calendar: '\uEA0D',
  event_pages_close_button: '\uEA0E',
  event_pages_continents: '\uEA0F',
  event_pages_down_arrow: '\uEA10',
  event_pages_down_arrow_1: '\uEA11',
  event_pages_dropdown_arrow: '\uEA12',
  event_pages_fullscreen_button: '\uEA13',
  event_pages_left_arrow: '\uEA14',
  event_pages_link_button: '\uEA15',
  event_pages_list: '\uEA16',
  event_pages_mute: '\uEA17',
  event_pages_pause_button: '\uEA18',
  event_pages_play_button: '\uEA19',
  event_pages_right_arrow: '\uEA1A',
  event_pages_speaker_high: '\uEA1B',
  event_pages_speaker_low: '\uEA1C',
  event_pages_up_arrow: '\uEA1D',
  event_pages_webinar: '\uEA1E',
  // ===== fallback =====
  default: '\uf111', // circle
};
